export default {
    HEADER: 'Company owner',
    PLACEHOLDER_FIRST_NAME: 'Enter first name',
    LABEL_NAME: 'First name',
    PLACEHOLDER_LAST_NAME: 'Enter last name',
    LABEL_LAST_NAME: 'Last name',
    PLACEHOLDER_EMAIL: 'Enter email address',
    LABEL_EMAIL: 'Email',
    PLACEHOLDER_ENTER_PASSWORD: 'Enter password',
    LABEL_NEW_PASSWORD: 'New password',
    PLACEHOLDER_NEW_PASSWORD: 'Enter new password',
    LABEL_PASSWORD: 'Password',
    PLACEHOLDER_PHONE_NUMBER: 'Enter phone number',
    LABEL_PHONE_NUMBER: 'Phone number',
};
